import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { getSheduleAppointments } from "../../services/sheduleAppointmentsServices";
import MentorCalendar from "./CalenderSchedule";

const ScheduleTimings = () => {
  const mentorProfile = useSelector((state) => state.mentor.profile);
  const [schedule, setSchedule] = useState([]);
  const fetchSchedule = async () => {
    try {
      const data = await getSheduleAppointments({
        userId: mentorProfile.userId,
      });

      setSchedule(data);
    } catch (error) {
      console.error("Error fetching schedule:", error);
    }
  };

  useEffect(() => {
    fetchSchedule();
  }, [mentorProfile.userId]);

  return (
    <div>
      <MentorCalendar schedule={schedule} />
    </div>
  );
};

export default ScheduleTimings;
